
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniaonrentinpunecontactnumber() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Pune Contact Number  ',
        heading: 'Amruta Travels: Urbania On Rent in Pune Contact Number   ',
        headingDescription: 'Amruta Travels offers Urbania On Rent in Pune, providing a premium and reliable solution for group travel, including corporate trips, family outings, airport transfers, school excursions, and weekend getaways. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities to ensure a comfortable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania rental in Pune safe, convenient, and hassle-free. For bookings and inquiries, contact us at [Insert Contact Number] and travel together in comfort and style.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Urbania bus on rent in Pune",
      "description": "Call now to book Urbania bus on rent in Pune with comfortable AC seating for city travel, airport transfers, outstation trips, and group tours.",
      "contact": "+91 7353109555"
    },
    {
      "name": "Force Urbania bus rental Pune",
      "description": "Force Urbania bus rental service in Pune for corporate trips, family outings, and VIP travel with professional drivers and premium interiors.",
      "contact": "+91 7353109555"
    },
    {
      "name": "Urbania bus hire Pune",
      "description": "Urbania bus hire in Pune for city tours, airport pickup/drop, and outstation travel with AC comfort and 13/17 seater options.",
      "contact": "+91 7353109555"
    },
    {
      "name": "Urbania bus rental service Pune",
      "description": "Reliable Urbania bus rental service in Pune offering flexible rental plans for corporate, weddings, and group trips.",
      "contact": "+91 7353109555"
    },
    {
      "name": "Urbania bus booking Pune",
      "description": "Book Urbania bus in Pune online or via call for family trips, city tours, and corporate travel with professional drivers.",
      "contact": "+91 7353109555"
    },
    {
      "name": "13 seater Urbania bus Pune",
      "description": "Comfortable 13 seater Urbania bus hire in Pune for small families, corporate teams, and airport transfers with AC interiors.",
      "contact": "+91 7353109555"
    },
    {
      "name": "17 seater Urbania bus Pune",
      "description": "Spacious 17 seater Urbania bus rental in Pune ideal for large groups, corporate trips, weddings, and factory staff transport.",
      "contact": "+91 7353109555"
    },
    {
      "name": "Luxury Urbania bus hire Pune",
      "description": "Luxury Urbania bus rental in Pune for VIP travel, corporate events, and premium family trips with elegant interiors.",
      "contact": "+91 7353109555"
    },
    {
      "name": "AC Urbania bus Pune",
      "description": "Air-conditioned Urbania bus hire in Pune ensuring cool and comfortable travel for city tours, outstation trips, and airport transfers.",
      "contact": "+91 7353109555"
    },
    {
      "name": "Urbania corporate bus hire Pune",
      "description": "Corporate Urbania bus hire in Pune for office staff transport, meetings, conferences, and corporate events with professional service.",
      "contact": "+91 7353109555"
    }
  ],
"tableData": [
    ["Urbania bus on rent in Pune contact number", "Force Urbania bus rental Pune contact number"],
    ["Urbania bus hire Pune phone number", "Urbania bus rental service Pune contact"],
    ["Urbania bus on rent Pune enquiry number", "Urbania bus booking Pune contact number"],
    ["Urbania bus hire Pune call now", "Urbania bus rental Pune customer care number"],
    ["Urbania bus service Pune mobile number", "Urbania bus rental Pune WhatsApp number"],
    ["13 seater Urbania bus Pune contact number", "17 seater Urbania bus Pune contact number"],
    ["Luxury Urbania bus hire Pune contact", "AC Urbania bus rental Pune phone"],
    ["Urbania bus on rent near me Pune contact number", "Urbania bus rental Baner Pune contact"],
    ["Urbania bus hire Kothrud Pune contact", "Urbania bus rental Hadapsar Pune phone"],
    ["Urbania bus hire Pimpri Chinchwad contact", "Urbania bus Pune Airport contact number"],
    ["Urbania corporate bus hire Pune contact", "Urbania bus for corporate Pune phone"],
    ["Urbania bus airport pickup Pune contact", "Urbania bus rent Pune price contact number"],
    ["Urbania bus hire Pune per km rate contact", "Affordable Urbania bus Pune contact"],
    ["Cheap Urbania bus rental Pune phone", "Book Urbania bus Pune contact number"],
    ["Online Urbania bus booking Pune contact", "Hire Urbania bus Pune with driver contact"],
    ["Urbania bus rental Pune enquiry", "Urbania Bus On Rent in Pune Contact Number"],
    ["13 & 17 Seater Urbania Bus Hire Pune Contact", "Urbania Bus Rental Service Pune Call Now"]
  ],

  

"whychoose": [
  {
    "WhyChooseheading": "Contact Urbania On Rent in Pune Easily",
    "WhyChoosedescription": "Amruta Travels makes it simple to book an Urbania On Rent in Pune. Reach out to us directly at 📞 +91‑7353109555 to get a quick quote, ask questions, and confirm your booking."
  },
  {
    "WhyChooseheading": "Quick Support for Booking and Queries",
    "WhyChoosedescription": "Call our Pune contact number for instant assistance with vehicle availability, pricing per km or per day, driver details, and any special travel requests."
  },
  {
    "WhyChooseheading": "Speak to Our Travel Specialists",
    "WhyChoosedescription": "Our friendly and knowledgeable support team is available via phone to guide you through booking the perfect Urbania for your trip—whether it’s local, outstation, or airport transfers."
  },
  {
    "WhyChooseheading": "24/7 Contact for Urgent Travel Needs",
    "WhyChoosedescription": "Need last‑minute travel plans or a same‑day booking? Call 📞 +91‑7353109555 anytime—our team is ready to help you with seamless Urbania rentals in Pune."
  },
  {
    "WhyChooseheading": "Transparent and Honest Communication",
    "WhyChoosedescription": "When you call our Pune contact number, we provide clear information on pricing, routes, driver policies, and vehicle features without hidden costs."
  },
  {
    "WhyChooseheading": "Personalized Booking Support",
    "WhyChoosedescription": "Whether it’s a family trip, corporate travel, or special event, our team will understand your needs and guide you to the best Urbania rental plan."
  },
  {
    "WhyChooseheading": "Confirm Your Urbania Rental Over Call",
    "WhyChoosedescription": "Talk to us directly to confirm your booking, get a detailed itinerary, and receive all rental details instantly."
  },
  {
    "WhyChooseheading": "Easy Follow‑Up and Updates",
    "WhyChoosedescription": "After calling our Pune Urbania rental contact number, you can get ride updates, driver details, and support before and during your trip."
  }
]

    }

const faqData = [
  {
    question: 'What is the contact number to book Urbania on rent in Pune?',
    answer: 'You can call Amruta Travels at 📞 +91‑7353109555 to inquire about Urbania rental availability, pricing, and booking details in Pune.'
  },
  {
    question: 'Can I get assistance over the phone for my booking?',
    answer: 'Yes, our team is available via phone to help you with vehicle selection, fare details, routes, pickup/drop‑off options, and any special requirements.'
  },
  {
    question: 'What information should I share when I call?',
    answer: 'When you call, share your travel date, number of passengers, pickup and drop‑off locations, and trip type (local/outstation) to get an accurate quote.'
  },
  {
    question: 'Is the contact number available 24/7?',
    answer: 'Yes, you can call 📞 +91‑7353109555 anytime for urgent support, queries, or last‑minute bookings for Urbania rentals in Pune.'
  },
  {
    question: 'Can I book my Urbania rental entirely over the phone?',
    answer: 'Absolutely! You can confirm your booking, make payment arrangements, and get all details finalized by calling our contact number.'
  },
  {
    question: 'Are there any charges for calling the contact number?',
    answer: 'Normal call charges apply as per your telecom provider. There are no extra fees for calling our booking support number.'
  },
  {
    question: 'Can the support team help with customized routes and plans?',
    answer: 'Yes, our phone support team can help you plan custom routes, stops, and schedules based on your travel needs.'
  },
  {
    question: 'Why should I call instead of booking online?',
    answer: 'Calling 📞 +91‑7353109555 gives you direct access to our support team, faster personalized responses, and instant clarification on any questions you have about your Urbania rental.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Akash Gupta',
    role: 'Family Traveler, Pune',
    text: 'I called Amruta Travels at their Pune contact number to book an Urbania. The support team was helpful, provided a great quote, and made the booking process smooth and easy!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Lata Sharma',
    role: 'Event Planner, Pune',
    text: 'Booked an Urbania for our event through a phone call. The process was quick and clear, and the vehicle arrived on time. Excellent service by Amruta Travels!',
    rating: 5
  }
];
































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const urbaniaContactSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Urbania Bus Rental Pune",
  "image": "https://bushireinpune.com/assets/images/urbania-pune.jpg",
  "description": "Contact Urbania Bus Rental Pune for 13 & 17 seater Urbania buses, luxury & AC buses for family trips, corporate events, airport transfers, Pune Darshan, and outstation travel. Call or WhatsApp +91 7353109555 for bookings and enquiries.",
  "telephone": "+917353109555",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+917353109555",
    "contactType": "customer service",
    "areaServed": "IN",
    "availableLanguage": "en"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your Street Address Here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "4110XX",
    "addressCountry": "IN"
  },
  "url": "https://bushireinpune.com",
  "sameAs": [
    "https://www.facebook.com/urbania.pune",
    "https://www.instagram.com/urbania.pune"
  ],
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 06:00-22:00"
};







    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Urbania Bus Rental Pune | Contact Number +91 7353109555</title>
  <meta
    name="description"
    content="Call or WhatsApp +91 7353109555 for Urbania bus rental in Pune. 13 & 17 seater Urbania buses, luxury & AC buses for family trips, corporate travel, airport transfer, Pune Darshan, and outstation tours."
  />
  <script type="application/ld+json">
    {JSON.stringify(urbaniaContactSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/125.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinpunecontactnumber;